import { useEffect } from "react";

/**
 * SEO — updates document title, meta description, OG basics and <html lang>.
 * Intentionally no external dep. Runs on every prop change.
 */
export function SEO({ title, description, lang }) {
    useEffect(() => {
        if (title) document.title = title;
        if (lang) document.documentElement.lang = lang;
        if (description) setMeta("description", description, false);
        if (title) setMeta("og:title", title, true);
        if (description) setMeta("og:description", description, true);
        setMeta("og:type", "website", true);
    }, [title, description, lang]);
    return null;
}

function setMeta(name, content, isProperty) {
    const selector = isProperty
        ? `meta[property="${name}"]`
        : `meta[name="${name}"]`;
    let tag = document.head.querySelector(selector);
    if (!tag) {
        tag = document.createElement("meta");
        if (isProperty) {
            tag.setAttribute("property", name);
        } else {
            tag.setAttribute("name", name);
        }
        document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
}
